import React, { useEffect, useState, useContext } from 'react'
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import OpenInNewSharpIcon from '@mui/icons-material/OpenInNewSharp';
import ReactTable from 'components/common/ReactTable';
import { useForm, Controller } from 'react-hook-form';
import SearchableDropdown from 'components/common/SearchableDropdown';
import ReactDatePicker from 'components/common/ReactDatePicker';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { checkModulePermission } from 'components/common/helper-function/ModulePermissionCheck';
import './report.css'
import { errorMessage } from 'components/common/helper-function/catchErrorMessage';
import { getListOfDepartment, getListOfVisitortype, getListOfregister } from 'services/adminmoduleService'
import { loaderContext } from 'context/Context';
import { bookingsreportlist } from 'services/reportsService'
import moment from 'moment';





function BookingsReport() {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    const { isLoading, setIsLoading } = useContext(loaderContext)
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [bookingreportdata, setBookingReportData] = useState([]);
    const [departmentOption, setDepartmentOption] = useState([]);
    const [visitorTypeOption, setVisitorTypeOption] = useState([]);
    const [registerOption, setRegisterOption] = useState([]);
    const [visitorstatusOption, setVisitorStatusOption] = useState([{ label: "Login", value: "login" }, { label: "Logout", value: "logout" }]);

    // const [dateRange, setDateRange] = useState([null, null]);
    // const [startDate, endDate] = dateRange;

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
        control,
        setValue,
        setError,
        clearErrors,
        watch
    } = useForm();

    useEffect(async () => {
        checkModulePermission("Visitor Appointment Report")
        setIsLoading(true)
        try {
            const { data } = await getListOfDepartment()
            const { data: visitortype } = await getListOfVisitortype()
            const { data: booking } = await bookingsreportlist({})
            const { data: register } = await getListOfregister()
            setDepartmentOption(data?.data?.map((depart) => ({ label: depart?.name, value: depart?.id })))
            setVisitorTypeOption(visitortype?.data?.map((visitor) => ({ label: visitor?.name, value: visitor?.id })))
            setRegisterOption(register?.data?.filter((reg) => reg.role == 5).map((regis) => ({ label: regis?.name, value: regis?.id })))
            // setRegisterOption(register?.data?.map((register) => ({ label: register?.name, value: register?.id })))
            setBookingReportData(booking?.data)
        } catch (error) {
            errorMessage(error)
        }
        setIsLoading(false)
    }, [])
    const columns = [

        {
            Header: t('bookingreport.bookingreporttable.visitorname'),
            accessor: 'visitor_name',
            Cell: ({ row }) => {
                return row?.original?.visitor_name ? row?.original?.visitor_name : '--'
            }
        },
        {
            Header: t('bookingreport.bookingreporttable.mobileno'),
            accessor: 'phone_number',
            Cell: ({ row }) => {
                return row?.original?.phone_number ? `${row?.original?.country_code}-${row?.original?.phone_number}` : '--'
            }
        },
        {
            Header: t('bookingreport.bookingreporttable.idno'),
            accessor: 'document_id_number',
            Cell: ({ row }) => {
                return row?.original?.document_id_number ? row?.original?.document_id_number : '--'
            }
        },
        {
            Header: t('bookingreport.bookingreporttable.idtype'),
            accessor: 'document_id_type',
            Cell: ({ row }) => {
                return row?.original?.document_id_type ? row?.original?.document_id_type : '--'
            }
        },
        {
            Header: t('bookingreport.bookingreporttable.department'),
            accessor: 'department_name',
            Cell: ({ row }) => {
                return row?.original?.department_name ? row?.original?.department_name : '--'
            }
        },
        {
            Header: t('bookingreport.bookingreporttable.host'),
            accessor: 'host_name',
            Cell: ({ row }) => {
                return row?.original?.host_name ? row?.original?.host_name : '--'
            }
        },
        {
            Header: t('bookingreport.bookingreporttable.accesscardno'),
            accessor: 'access_card_no',
            Cell: ({ row }) => {
                return row?.original?.access_card_no ? row?.original?.access_card_no : '--'
            }
        },
        {
            Header: t('bookingreport.bookingreporttable.appointmentid'),
            accessor: 'appointment_id',
            Cell: ({ row }) => {
                return row?.original?.appointment_id ? row?.original?.appointment_id : '--'
            }
        },
        {
            Header: t('bookingreport.bookingreporttable.date'),
            accessor: 'date',
            Cell: ({ row }) => {
                return row?.original?.date ? moment.utc(row?.original?.date).local().format(process.env.REACT_APP_FILTER_DATE) : '--'
            }
        },
        {
            Header: t('bookingreport.bookingreporttable.timein'),
            accessor: 'time_in',
            Cell: ({ row }) => {
                return row?.original?.time_in ? moment.utc(row?.original?.time_in).local().format(process.env.REACT_APP_TIME_FORMAT_24) : "--"
            },
        },
        {
            Header: t('bookingreport.bookingreporttable.timeout'),
            accessor: 'time_out',
            Cell: ({ row }) => {
                return row?.original?.time_out ? moment.utc(row?.original?.time_out).local().format(process.env.REACT_APP_TIME_FORMAT_24) : "--"
            },
        },
        {
            Header: t('bookingreport.bookingreporttable.duration'),
            accessor: 'duration',
            Cell: ({ row }) => {
                return row?.original?.duration ? row?.original?.duration : '--'
            }
        },

    ];

    const onSubmit = async (bookingData) => {
        console.log("bookingData", bookingData)
        setIsLoading(true)

        if (bookingData?.department_id || bookingData?.visitor_type || bookingData?.register_by || bookingData?.visitor_status || (startDate && endDate)) {
            try {
                bookingData.department_id = bookingData.department_id?.value
                bookingData.visitor_type = bookingData.visitor_type?.value
                bookingData.register_by = bookingData.register_by?.value
                bookingData.visitor_status = bookingData.visitor_status?.value
                if (startDate && endDate) {
                    bookingData.date_range = `${moment(startDate).format(process.env.REACT_APP_FILTER_DATE)}-${moment(endDate).format(process.env.REACT_APP_FILTER_DATE)}`;
                }
                const { data } = await bookingsreportlist(bookingData)
                setBookingReportData(data?.data)
            } catch (e) {
                if (e.response.data) {
                    if (Array.isArray(e.response.data.message)) {
                        e.response.data.message.map(errors => toast.error(errors, toastConfig))
                    } else {
                        toast.error(e.response.data.message, toastConfig)
                    }
                } else {
                    toast.error(e.message, toastConfig)
                }
            }
        }
        setIsLoading(false)


    };

    const downloadPDF = () => {
        const docDefinition = {
            pageOrientation: 'landscape',
            pageSize: { width: 1000, height: 600 },
            content: [
                { text: 'User Data', style: 'header' },
                { text: '\n' },
                {
                    table: {
                        headerRows: 1,
                        widths: Array.from({ length: columns.length }, () => 'auto'),
                        body: [
                            columns.map((column) => column.Header),
                            ...bookingreportdata.map((row) => columns.map((column) => {
                                if (column.accessor === 'time_in' || column.accessor === 'time_out') {
                                    return row[column.accessor] && row[column.accessor] != "" ? moment.utc(row[column.accessor]).local().format(process.env.REACT_APP_TIME_FORMAT_24) : '--';
                                } else if (column.accessor === 'phone_number') {
                                    const phoneNumber = row['phone_number'];
                                    const countryCode = row['country_code'];
                                    return phoneNumber && phoneNumber !== "" ? `${countryCode} ${phoneNumber}` : '--';
                                } else {
                                    return row[column.accessor] !== undefined ? row[column.accessor] : '';
                                }

                            })),
                        ],
                    },
                },
            ],
            defaultStyle: {
                actionHeader: false,
            },
            styles: {
                header: {
                    fontSize: 18,
                    bold: true,
                },
            },
        };

        const pdfDocGenerator = pdfMake.createPdf(docDefinition);
        pdfDocGenerator.download('bookings_data.pdf');
    };

    const downloadCSV = () => {
        const csvData = [
            columns.map((column) => column.Header),
            ...bookingreportdata.map((row) => columns.map((column) => {
                if (column.accessor === 'time_in' || column.accessor === 'time_out') {
                    return row[column.accessor] && row[column.accessor] != "" ? moment.utc(row[column.accessor]).local().format(process.env.REACT_APP_TIME_FORMAT_24) : '--';
                } else if (column.accessor === 'phone_number') {
                    const phoneNumber = row['phone_number'];
                    const countryCode = row['country_code'];
                    return phoneNumber && phoneNumber !== "" ? `${countryCode} ${phoneNumber}` : '--';
                } else {
                    return row[column.accessor] !== undefined ? row[column.accessor] : '';
                }
            })),
        ]
            .map((row) => row.join(','))
            .join('\n');

        const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8' });
        saveAs(blob, 'bookings_data.csv');
    };

    return (
        <div className="row g-3 mb-3">
            {/* <div className=""> */}
            <div className="card overflow-hidden mb-3 col-sm-12 col-md-12 col-lg-9 data-table" style={{ height: "fit-content" }}>
                <div className="card-header">
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-4 heading-text">
                            <h3 className="heading-color fw-600 mb-0">
                                {t('bookingreport.heading')}
                            </h3>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-8 table-btn" >
                            <button
                                className="btn btn-primary btn-sm float-end"
                                onClick={() => downloadPDF()}
                            >
                                <OpenInNewSharpIcon />
                                {/* <FontAwesomeIcon icon="plus" /> */}
                                <span className="ms-1 d-sm-inline ">
                                    {t('bookingreport.exportpdfbtn')}
                                </span>
                            </button>

                            <button
                                className="btn mx-1 btn-primary btn-sm float-end"
                                onClick={() => downloadCSV()}
                            >
                                <OpenInNewSharpIcon />
                                {/* <FontAwesomeIcon icon="plus" /> */}
                                <span className="ms-1 d-sm-inline">
                                    {t('bookingreport.exportcsvbtn')}
                                </span>
                            </button>
                        </div>

                        <div className="col-12">
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="card-body pt-0">
                    <ReactTable
                        columns={columns}
                        data={bookingreportdata}
                        pageSizeOption={[5, 10, 15, 20]}
                        headerClass="btn-primary"
                        widthClass="table-width"
                        isSearchBoxVisible
                        ispaginationvisible={true}
                    />
                </div>
            </div>


            <div className='card overflow-hidden mb-3 col-sm-12 col-md-12 col-lg-2 filter-table' style={{ padding: "0rem .8rem 0rem .8rem", height: "fit-content" }}>
                <form onSubmit={handleSubmit(onSubmit)}>

                    <div className='row' style={{ backgroundColor: "rgb(247, 247, 247)", paddingTop: ".8rem", height: "3rem", color: "black", marginBottom: '1rem' }}>
                        <span>{t('bookingreport.filterheading')}</span>
                    </div>

                    <div className="form-group col-12 mb-3">
                        <label>
                            {t('bookingreport.filterform.department')}
                        </label>
                        <Controller
                            name="department_id"
                            control={control}
                            // rules={{ required: true }}
                            render={({ field: { value, onChange } }) => (
                                <SearchableDropdown
                                    value={value}
                                    onChange={onChange}
                                    options={departmentOption}
                                    hasError={errors.department_id}
                                // placeholder={t('suppliercontractor.createsupplierplaceholder.selectcompanytype')}
                                />
                            )}
                        />
                        {/* {errors.department && (
                            <small>
                                {errors.department.type === 'required' && (
                                    <span className="text-danger">
                                        {t('bookingreport.error.departmenterror')}
                                    </span>
                                )}
                            </small>
                        )} */}
                    </div>
                    <div className="form-group col-12 mb-3">
                        <label>
                            {t('bookingreport.filterform.visitortype')}
                        </label>
                        <Controller
                            name="visitor_type"
                            control={control}
                            // rules={{ required: true }}
                            render={({ field: { value, onChange } }) => (
                                <SearchableDropdown
                                    value={value}
                                    onChange={onChange}
                                    options={visitorTypeOption}
                                    hasError={errors.visitor_type}
                                    placeholder={t('bookingreport.placeholder.visitortype')}
                                />
                            )}
                        />
                        {/* {errors.visitortype && (
                            <small>
                                {errors.visitortype.type === 'required' && (
                                    <span className="text-danger">
                                        {t('bookingreport.error.visitortypeerror')}
                                    </span>
                                )}
                            </small>
                        )} */}
                    </div>
                    <div className="form-group col-12 mb-3">
                        <label>
                            {t('bookingreport.filterform.visitorstatus')}
                        </label>
                        <Controller
                            name="visitor_status"
                            control={control}
                            // rules={{ required: true }}
                            render={({ field: { value, onChange } }) => (
                                <SearchableDropdown
                                    value={value}
                                    onChange={onChange}
                                    options={visitorstatusOption}
                                    hasError={errors.visitor_status}
                                    placeholder={t('bookingreport.placeholder.visitorstatus')}
                                />
                            )}
                        />
                        {/* {errors.visitorstatus && (
                            <small>
                                {errors.visitorstatus.type === 'required' && (
                                    <span className="text-danger">
                                        {t('bookingreport.error.visitorstatuserror')}
                                    </span>
                                )}
                            </small>
                        )} */}
                    </div>
                    <div className="form-group col-12 mb-3">
                        <label>
                            {t('bookingreport.filterform.registerby')}
                        </label>
                        <Controller
                            name="register_by"
                            control={control}
                            // rules={{ required: true }}
                            render={({ field: { value, onChange } }) => (
                                <SearchableDropdown
                                    value={value}
                                    onChange={onChange}
                                    options={registerOption}
                                    hasError={errors.register_by}
                                    placeholder={t('bookingreport.placeholder.registerby')}
                                />
                            )}
                        />
                        {/* {errors.registerby && (
                            <small>
                                {errors.registerby.type === 'required' && (
                                    <span className="text-danger">
                                        {t('bookingreport.error.registerbyerror')}
                                    </span>
                                )}
                            </small>
                        )} */}
                    </div>
                    <div className="form-group col-12 mb-3">
                        <label>
                            {t('bookingreport.filterform.daterange')}
                        </label>
                        <Controller
                            name="date_range"
                            control={control}
                            // rules={{ required: true }}
                            render={({ field: { value, onChange } }) => (
                                <>
                                    {/* <ReactDatePicker
                                    value={value}
                                    // onChange={onChange}
                                    onChange={(update) => {
                                        setDateRange(update);
                                    }}
                                    placeholder={t(
                                        'bookingreport.placeholder.date'
                                    )}
                                    hasErrors={errors.date_range}
                                    dateFormat="dd-MM-yyyy"
                                    startDate={startDate}
                                    endDate={endDate}
                                    selectsRange={true}
                                // isClearable={true}
                                /> */}
                                    <ReactDatePicker
                                        selected={startDate}
                                        value={startDate}
                                        onChange={(date) => setStartDate(date)}
                                        placeholder={t('summaryreport.placeholder.startdate')}
                                        dateFormat="dd/MM/yyyy"
                                        selectsStart
                                        startDate={startDate}
                                        endDate={endDate}
                                        maxDate={endDate || undefined}
                                    />
                                    {/* <span className="mx-2">-</span> */}
                                    <br />
                                    <ReactDatePicker
                                        selected={endDate}
                                        value={endDate}
                                        onChange={(date) => setEndDate(date)}
                                        placeholder={t('summaryreport.placeholder.enddate')}
                                        dateFormat="dd/MM/yyyy"
                                        selectsEnd
                                        startDate={startDate}
                                        endDate={endDate}
                                        minDate={startDate || undefined}
                                    />
                                </>
                            )}
                        />
                        {/* {errors.date && (
                            <small>
                                {errors.date.type === 'required' && (
                                    <span className="text-danger">
                                        {t('bookingreport.error.dateerror')}
                                    </span>
                                )}
                            </small>
                        )} */}
                    </div>

                    <div className="text-start col-12">
                        <div className="mb-3 mt-4 text-start">
                            <button type="submit" className="col-lg-12 btn btn-primary me-1">
                                {t('bookingreport.filterform.filterbtn')}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            {/* </div> */}
        </div>
    )
}

export default BookingsReport